import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { AppIcon } from "../AppIcon";
import Box from "../Box";
import type { CmeDownloadNoticeData } from "./types";

type Props = {
	notice: CmeDownloadNoticeData;
};

export const CmeDownloadNotice = ({ notice }: Props) => {
	const theme = useAppTheme();

	return (
		<Box
			flexDirection="row"
			alignItems="center"
			gap={12}
			paddingHorizontal={16}
			paddingVertical={12}
			borderRadius={theme.roundness * 3}
			backgroundColor={theme.colors.secondaryContainer}
		>
			<AppIcon
				name="check-circle-outline"
				size={24}
				color={theme.colors.onSecondaryContainer}
			/>
			<Text
				variant="bodySmall"
				style={{ flex: 1, color: theme.colors.onSecondaryContainer }}
			>
				{`${notice.text} `}
				<Text
					variant="bodySmall"
					accessibilityRole="link"
					accessibilityLabel={notice.linkLabel}
					onPress={notice.onLinkPress}
					style={{
						color: theme.colors.onSecondaryContainer,
						fontWeight: "600",
						textDecorationLine: "underline",
					}}
				>
					{notice.linkLabel}
				</Text>
			</Text>
		</Box>
	);
};
